export default __webpack_public_path__ + "static/media/spinner.f6f0e212.gif";